<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="customerVehiclesHeadings" :data="customerVehicles" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onCustomerVehiclesActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button id="btnAddCustomerVehicle" class="btn btn-primary" @click="onAddCustomerVehicleClick">Add Customer Vehicle</button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                               :componentId="'customerFilterRadioButtons'"
                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="customerVehicleMarkAsActiveInactiveModal.heading"
                :modalId="customerVehicleMarkAsActiveInactiveModal.modalId"
                :isSaving="customerVehicleMarkAsActiveInactiveModal.isSaving"
                :showModal="customerVehicleMarkAsActiveInactiveModal.showModal"
                :isActive="customerVehicleMarkAsActiveInactiveModal.isActive"
                @closeClicked="customerVehicleMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>

    <modal-form
        :heading="customerVehicleAddOrEditModal.heading"
        :modalId="customerVehicleAddOrEditModal.modalId"
        :isSaving="customerVehicleAddOrEditModal.isSaving"
        :showModal="customerVehicleAddOrEditModal.showModal"
        @closeClicked="onAddOrEditCustomerVehicleModalCloseClick"
        @saveButtonClicked="onAddOrEditCustomerVehicleSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="makeInput">
                        Make
                    </label>
                    <div class="text-danger" v-if="customerVehicleAddOrEditModal.vehicle.make.hasError">
                        {{customerVehicleAddOrEditModal.vehicle.make.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="makeInput" v-model="customerVehicleAddOrEditModal.vehicle.make.value">
                </div>
                <div class="form-group">
                    <label for="modelInput">
                        Model
                    </label>
                    <div class="text-danger" v-if="customerVehicleAddOrEditModal.vehicle.model.hasError">
                        {{customerVehicleAddOrEditModal.vehicle.model.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="modelInput" v-model="customerVehicleAddOrEditModal.vehicle.model.value">
                </div>
                <div class="form-group">
                    <label for="yearInput">
                        Year
                    </label>
                    <div class="text-danger" v-if="customerVehicleAddOrEditModal.vehicle.year.hasError">
                        {{customerVehicleAddOrEditModal.vehicle.year.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="yearInput" v-model="customerVehicleAddOrEditModal.vehicle.year.value">
                </div>
                <div class="form-group">
                    <label for="registrationInput">
                        Vehicle Registration
                    </label>
                    <div class="text-danger" v-if="customerVehicleAddOrEditModal.vehicle.registration.hasError">
                        {{customerVehicleAddOrEditModal.vehicle.registration.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="registrationInput" v-model="customerVehicleAddOrEditModal.vehicle.registration.value">
                </div>
                <div class="form-group">
                    <label for="trailerRegistrationInput">
                        Trailer Registration
                    </label>
                    <div class="text-danger" v-if="customerVehicleAddOrEditModal.vehicle.trailerRegistration.hasError">
                        {{customerVehicleAddOrEditModal.vehicle.trailerRegistration.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="trailerRegistrationInput" v-model="customerVehicleAddOrEditModal.vehicle.trailerRegistration.value">
                </div>
                <div class="form-group">
                    <label for="fleetNumberInput">
                        Fleet Number
                    </label>
                    <div class="text-danger" v-if="customerVehicleAddOrEditModal.vehicle.fleetNumber.hasError">
                        {{customerVehicleAddOrEditModal.vehicle.fleetNumber.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="fleetNumberInput" v-model="customerVehicleAddOrEditModal.vehicle.fleetNumber.value">
                </div>
                <div class="form-group">
                    <label for="capacityInput">
                        Capacity (Litres)
                    </label>
                    <div class="text-danger" v-if="customerVehicleAddOrEditModal.vehicle.capacity.hasError">
                        {{customerVehicleAddOrEditModal.vehicle.capacity.errorMessage}}
                    </div>
                    <input type="number" class="form-control" id="capacityInput" v-model="customerVehicleAddOrEditModal.vehicle.capacity.value">
                </div>
            </form>
        </template>
    </modal-form>
</div>
